<template>
  <vx-card>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="getProfileImage(thumbnail_profile_image_user)" size="70px" class="mr-4 mb-4" v-if="this.dataImg === null"/>
      <cropper classname="cropper" ref="cropper" :src="this.dataImg" :stencil-props="{aspectRatio: 12/12}" @change="change" stencil-component="circle-stencil" v-else></cropper>
      <vs-avatar :src="this.dataImg" size="70px" class="mr-4 mb-4" v-if="this.isImageCropped == true"/>
      <div class="ml-4 mt-2 sm:mt-0">
        <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept=".jpg,.jpeg,.png">
        <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.uploadImgInput.click()" v-if="!this.dataImg">Subir foto</vs-button>
        <vs-button class="mr-4 sm:mb-0 mb-2" type="border" @click="$refs.uploadImgInput.click()" v-if="this.dataImg">Subir otra foto</vs-button>
        <vs-button class="mr-4 sm:mb-0 mb-2" type="border" color="warning" @click="reset()" v-if="this.dataImg">Reset</vs-button>
        <vs-button class="mr-4 sm:mb-0 mb-2" type="border" color="warning" @click="crop()" v-if="this.dataImg">Cortar</vs-button>
        <vs-button class="mr-4 sm:mb-0 mb-2" color="primary" @click="guardarAvatar()" v-if="this.dataImg">Guardar Avatar</vs-button>
        <p class="text-sm mt-2">Se permite sólo JPG o PNG. El tamaño mínimo de la imagen debe ser 300px.</p>
        <p class="text-sm mt-2" v-if="this.dataImg !== null">Dimensiones recorte: {{ this.coordinates.width }}x{{ this.coordinates.height }} </p>
      </div>
    </div>
    

    <!-- Append Button USERNAME -->
    <small class="ml-2">Nombre de Usuario</small>
    <vx-input-group class="">
      <vs-input v-model="username_user" name="username_user" v-validate="{ regex: /^(\d|\w){6,}$/ }"/>
      <template slot="append">
        <div class="append-text btn-addon">
          <vs-button color="primary" @click="submitUsername()" :disabled="!isUsernameValid">Guardar Nombre de Usuario</vs-button>
        </div>
      </template>
    </vx-input-group>
    <span class="text-danger text-sm" v-show="errors.has('username_user')">{{ errors.first('username_user') }}. Debe ser mayor a 6 caracteres y éstos no pueden ser: *, #, =, ¿, ?, ¡, ! o espacios en blanco.</span>
    <!-- /Append Button USERNAME-->

    <vs-divider class="mt-8"> + Datos </vs-divider>

    <!-- EMAIL, DEPARTAMENTO, ROL Y SEDE -->
    <div class="vx-row">
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Email" v-model="email_user" name="email_user" v-validate="'email'" disabled></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Sede" v-model="name_headquarter" name="name_headquarter" v-validate="''" disabled></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Departamento" v-model="name_department" name="name_department" v-validate="''" disabled></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Rol - Cargo" v-model="name_role" name="name_role" v-validate="''" disabled></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('email_user')">{{ errors.first('email_user') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('name_headquarter')">{{ errors.first('name_headquarter') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('name_department')">{{ errors.first('name_department') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('name_role')">{{ errors.first('name_role') }}</span>
    </div>

    <!-- NOMBRES Y APELLIDOS -->
    <div class="vx-row">
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Primer nombre" v-model="name_employee" name="name_employee" v-validate="'alpha_spaces'"></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Segundo nombre" v-model="second_name_employee" name="second_name_employee" v-validate="'alpha_spaces'"></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Primer apellido" v-model="surname_employee" name="surname_employee" v-validate="'alpha_spaces'"></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Segundo apellido" v-model="second_surname_employee" name="second_surname_employee" v-validate="'alpha_spaces'"></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('name_employee')">{{ errors.first('name_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('second_name_employee')">{{ errors.first('second_name_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('surname_employee')">{{ errors.first('surname_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('second_surname_employee')">{{ errors.first('second_surname_employee') }}</span>
    </div>


    <!-- NIF/NIE, ESTADO CIVIL, EMAIL PERSONAL, FECHA DE NACIMIENTO -->
    <div class="vx-row">
      <vs-input class="vx-col w-full sm:w-1/2 mb-2" label="NIF/NIE" v-model="nif_employee" name="nif_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/2 mb-2" label="Email Personal" v-model="personal_email_employee" name="personal_email_employee" v-validate="''" ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('nif_employee')">{{ errors.first('nif_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('personal_email_employee')">{{ errors.first('personal_email_employee') }}</span>
    </div>

    <!-- ESTADO CIVIL-->
    <div class="mb-2">
      <label class="text-sm">Estado Civil</label>
      <v-select :closeOnSelect="true" v-model="civil_status_employee" :options="civil_status_options" name="civil_status_employee"></v-select>
    </div>

    <!-- PAÍS PROCEDENCIA-->
    <!-- <div class="mb-2">
      <label class="text-sm">País de procedencia</label>
      <v-select :closeOnSelect="true" v-model="country_selected" :options="countries" name="country_selected"></v-select>
    </div> -->

    <!-- FECHA DE NACIMIENTO -->
    <div class="mb-2">
      <label class="text-sm ml-1">Fecha de nacimiento</label>
      <!-- <flat-pickr v-model="birthdate_client" :config="{ dateFormat: 'd F Y' }" class="w-full" /> -->
      <!-- <datepicker :language="languages[language]" v-model="birthdate_employee" name="birthdate_employee" :disabledDates="disabledDates"></datepicker> -->
    </div>

    <!-- TELEFONO MOVIL, TELEFONO DOMICILIO, CORPORATIVO MOVIL, CORPORATIVO LOCAL -->
    <div class="vx-row">
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Teléfono móvil" v-model="mobile_phone_employee" name="mobile_phone_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Teléfono domicilio" v-model="landline_employee" name="landline_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Corporativo Móvil" v-model="corporate_mobile_phone_employee" name="corporate_mobile_phone_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Corporativo Local" v-model="corporate_local_phone_employee" name="corporate_local_phone_employee" v-validate="''" ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('mobile_phone_employee')">{{ errors.first('mobile_phone_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('landline_employee')">{{ errors.first('landline_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('corporate_mobile_phone_employee')">{{ errors.first('corporate_mobile_phone_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('corporate_local_phone_employee')">{{ errors.first('corporate_local_phone_employee') }}</span>
    </div>

    <!-- DIRECCIÓN DOMICILIO, DIRECCIÓN FISCAL -->
    <div class="vx-row">
      <vs-input class="vx-col w-full sm:w-1/2 mb-2" label="Dirección Domicilio" v-model="address_employee" name="address_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/2 mb-2" label="Dirección Fiscal" v-model="fiscal_address_employee" name="fiscal_address_employee" v-validate="''" ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('address_employee')">{{ errors.first('address_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('fiscal_address_employee')">{{ errors.first('fiscal_address_employee') }}</span>
    </div>

    <!-- CONTACTO DE EMERGENCIA, TELEFONO DE CONTACTO DE EMERGENCIA, TIPO DE SANGRE, COLOR  -->
    <div class="vx-row">
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Contacto de emergencia" v-model="emergency_contact_employee" name="emergency_contact_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Telf. contacto emergencia" v-model="emergency_phone_employee" name="emergency_phone_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Tipo de Sangre" v-model="blood_type_employee" name="blood_type_employee" v-validate="''" ></vs-input>
      <vs-input class="vx-col w-full sm:w-1/4 mb-2" label="Color" v-model="color_employee" name="color_employee" v-validate="''" ></vs-input>
      <span class="text-danger text-sm" v-show="errors.has('emergency_contact_employee')">{{ errors.first('emergency_contact_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('emergency_phone_employee')">{{ errors.first('emergency_phone_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('blood_type_employee')">{{ errors.first('blood_type_employee') }}</span>
      <span class="text-danger text-sm" v-show="errors.has('color_employee')">{{ errors.first('color_employee') }}</span>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="submitData()">Guardar datos</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
    </div>
  </vx-card>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import axios from '@/axios.js'

export default {
  components: {
    Cropper,
    Datepicker,
    flatPickr,
    'v-select': vSelect
  },
  data () {
    return {
      id_employee: '',
      username_user: '',
      name_employee: '',
      second_name_employee: '',
      surname_employee: '',
      second_surname_employee: '',
      email_user: '',
      id_role: '',
      name_role: '',
      id_headquarter: '',
      name_headquarter: '', 
      id_department: '',
      name_department: '',
      identification_card_employee: '',
      civil_status_employee: '',
      birthdate_employee: '',
      admission_date_employee: '',
      address_employee: '',
      personal_email_employee: '',
      corporate_email_employee: '',
      nif_employee: '',
      fiscal_address_employee: '',
      job_title_employee: '',
      salary_employee: '',
      bank_account_employee: '',
      mobile_phone_employee: '',
      landline_employee: '',
      corporate_mobile_phone_employee: '',
      corporate_local_phone_employee: '',
      emergency_contact_employee: '',
      emergency_phone_employee: '',
      blood_type_employee: '',
      color_employee: '',
      flag_permission_employee: '',
      observation_flag_permission_employee: '',
      original_profile_image_user: '',
      thumbnail_profile_image_user: '',
      avatar_profile_image_user: '',
      flag_login_user: '',
      observation_flag_login_user: '',
      civil_status_options: ['Soltero(a)', 'Casado(a)', 'Divorciado(a)', 'Viudo(a)'],
      country_selected: '',
      language: 'es',
      languages: lang,
      disabledDates: {
        from: new Date() 
      },
      selectedFile: '',
      dataImg: null,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      image: null,
      isImageCropped: false,
      objUserDataFromLS: {}
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    clientInfo () {
      return this.$store.state.clientInfo
    },
    countries () {
      return this.$store.state.countries
    },
    isFormValid () {
      return !this.errors.any() && this.email_user
    },
    isUsernameValid () {
      return !this.errors.has('username_user') 
    }
  },
  methods: {
    getProfileImage (thumbnail_profile_image_user) {
      if (thumbnail_profile_image_user === null) return
      return (axios.defaults.baseURLnoAPI) + thumbnail_profile_image_user
    },
    birthdateToString (date) {
      if (date) {
        // //OBTENGO LA FECHA DEL CALENDARIO
        // const birthdateDate = new Date(date)
        // birthdateDate.setHours(0)
        // birthdateDate.setMinutes(0)
        // birthdateDate.setSeconds(0)
        // // console.log("fecha almacenada en calendario datepicker: ", birthdateDate)
        // //Extraigo el Año de la fecha
        // const dateYear = birthdateDate.getUTCFullYear()
        // // console.log("año: ", dateYear)
        // //Extraigo el mes. Le sumo uno, porque JS considera mes Enero como 0, y no como 1. Pequeña carpintenria para que almacene correctamente.
        // const dateMonth = birthdateDate.getUTCMonth() + 1
        // // console.log("mes: ", dateMonth)
        // // corrección para meses que tienen una cifra 1-9
        // if (dateMonth <= 9) var dateMonthCorrected = `0${  dateMonth}`
        // if (dateMonth >= 10) var dateMonthCorrected = dateMonth
        // //Extraigo el día de la fecha del calendario
        // const dateDay = birthdateDate.getUTCDate()
        // // console.log("dia: ", dateDay)
        // //correcion al día, agregando "0" si hace falta.
        // if (dateDay <= 9) var dateDayCorrected = `0${  dateDay}`
        // if (dateDay >= 10) var dateDayCorrected = dateDay
        // // console.log(dateYear.toString()+dateMonthCorrected.toString()+dateDayCorrected.toString())
        // return `${dateYear.toString()}/${dateMonthCorrected.toString()}/${dateDayCorrected.toString()}`
      }
      
    },
    reset () {
      this.dataImg = null
      this.isImageCropped = false
    },
    crop () {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      this.dataImg = canvas.toDataURL()
      this.isImageCropped = true
    },
    // eslint-disable-next-line no-unused-vars
    change ({coordinates, canvas}) {
      this.coordinates = coordinates
    },
    updateCurrImg (input) {
      this.dataImg = null
      this.isImageCropped = false
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.selectedFile = event.target.files[0]
      }
    },
    submitUsername () {
      const username = {
        username: this.username_user
      }
      this.$vs.loading()
      this.$store.dispatch('updateUsername', username)
        .then(() => { this.$vs.loading.close() })
        .then(() => {
          this.$vs.notify({
            title: 'Nombre de usuario guardado',
            text: 'El nombre de usuario ha sido guardado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 4000
          })
        })
        .catch((error) => {
          this.$vs.loading.close()
          const mensaje_error = error.response.data.errors
          if (typeof mensaje_error === 'object') {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Username error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          } else {
            this.$vs.notify({
              title: 'Username error',
              text: `${mensaje_error}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        })
    },
    guardarAvatar () {
      const { canvas } = this.$refs.cropper.getResult()
      if (canvas) {
        const form = new FormData()
        canvas.toBlob(blob => {
          form.append('image', blob)
          this.$vs.loading()
          this.$store.dispatch('updateEmployeeAvatar', form)
            .then(() => {
              this.$store.dispatch('fetchUserImageCorner')
            })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.dataImg = null
              this.isImageCropped = false  
            })
            .then(() => {
              this.$vs.notify({
                title: 'Avatar actualizado',
                text: 'Se ha actualizado su imagen de perfil',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              }) 
            })
            .then(() => { 
              this.$store.dispatch('fetchEmployeePerfil', this.objUserDataFromLS)
                .then((response) => {
                  const { original_profile_image_user, thumbnail_profile_image_user, avatar_profile_image_user } = JSON.parse(JSON.stringify(response.data.employee))
                  this.original_profile_image_user = original_profile_image_user
                  this.thumbnail_profile_image_user = thumbnail_profile_image_user
                  this.avatar_profile_image_user = avatar_profile_image_user
                })
            })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)
              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Avatar error',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
        }, 'image/jpeg', 'image/jpg', 'image/png')
        
      }

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.id_employee,
            name: this.name_employee,
            second_name: this.second_name_employee,
            surname: this.surname_employee,
            second_surname: this.second_surname_employee,
            identification_card: this.identification_card_employee,
            civil_status: this.civil_status_employee,
            birthdate: this.birthdateToString(this.birthdate_employee),
            // admission_date: this.birthdateToString(this.admission_date_employee),
            address: this.address_employee,
            personal_email: this.personal_email_employee,
            // corporate_email: this.corporate_email_employee,
            nif: this.nif_employee,
            fiscal_address: this.fiscal_address_employee,
            salary: this.salary_employee,
            bank_account: this.bank_account_employee,
            mobile_phone: this.mobile_phone_employee,
            landline: this.landline_employee,
            corporate_mobile_phone: this.corporate_mobile_phone_employee,
            corporate_local_phone: this.corporate_local_phone_employee,
            emergency_contact: this.emergency_contact_employee,
            emergency_phone: this.emergency_phone_employee,
            blood_type: this.blood_type_employee,
            // department_id: this.department_id,
            color: this.color_employee
            // flag_permission: this.flag_permission,
            // observation_flag_permission: this.observation_flag_permission,
            // headquarter_id: this.headquarter_id,
          }
          this.$vs.loading()
          this.$store.dispatch('updateEmployeePerfil', obj)
            .then(() => { this.$store.dispatch('fetchUserData') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Datos actualizados',
                text: 'Se han actualizado sus datos',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              }) 
            })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)

              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Registro Fallido',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
        }
      })
    }
  },
  created () {
    const obj = {
      employee_id: JSON.parse(localStorage.getItem('userInfo')).employee_id
    }
    this.objUserDataFromLS = obj
    this.$store.dispatch('fetchEmployeePerfil', this.objUserDataFromLS)
      .then((response) => {
        const { id_employee, username_user, name_employee, second_name_employee, surname_employee, second_surname_employee, email_user, id_role, name_role, id_headquarter, name_headquarter, id_department, name_department, identification_card_employee, civil_status_employee, birthdate_employee, admission_date_employee, address_employee, personal_email_employee, corporate_email_employee, nif_employee, fiscal_address_employee, job_title_employee, salary_employee, bank_account_employee, mobile_phone_employee, landline_employee, corporate_mobile_phone_employee, corporate_local_phone_employee, emergency_contact_employee, emergency_phone_employee, blood_type_employee, color_employee, flag_permission_employee, observation_flag_permission_employee, original_profile_image_user, thumbnail_profile_image_user, avatar_profile_image_user, flag_login_user, observation_flag_login_user } = JSON.parse(JSON.stringify(response.data.employee))
        this.id_employee = id_employee
        this.username_user = username_user
        this.name_employee = name_employee
        this.second_name_employee = second_name_employee
        this.surname_employee = surname_employee
        this.second_surname_employee = second_surname_employee
        this.email_user = email_user
        this.id_role = id_role
        this.name_role = name_role
        this.id_headquarter = id_headquarter
        this.name_headquarter = name_headquarter
        this.id_department = id_department
        this.name_department = name_department
        this.identification_card_employee = identification_card_employee
        this.civil_status_employee = civil_status_employee
        if (birthdate_employee === null) {
          this.birthdate_employee = null
        } else {
          const birthdate_employee_corrected = new Date(birthdate_employee)
          birthdate_employee_corrected.setDate(birthdate_employee_corrected.getDate() + 1)
          this.birthdate_employee = birthdate_employee_corrected
        }
        this.admission_date_employee = admission_date_employee
        this.address_employee = address_employee
        this.personal_email_employee = personal_email_employee
        this.corporate_email_employee = corporate_email_employee
        this.nif_employee = nif_employee
        this.fiscal_address_employee = fiscal_address_employee
        this.job_title_employee = job_title_employee
        this.salary_employee = salary_employee
        this.bank_account_employee = bank_account_employee
        this.mobile_phone_employee = mobile_phone_employee
        this.landline_employee = landline_employee
        this.corporate_mobile_phone_employee = corporate_mobile_phone_employee
        this.corporate_local_phone_employee = corporate_local_phone_employee
        this.emergency_contact_employee = emergency_contact_employee
        this.emergency_phone_employee = emergency_phone_employee
        this.blood_type_employee = blood_type_employee
        this.color_employee = color_employee
        this.flag_permission_employee = flag_permission_employee
        this.observation_flag_permission_employee = observation_flag_permission_employee
        this.original_profile_image_user = original_profile_image_user
        this.thumbnail_profile_image_user = thumbnail_profile_image_user
        this.avatar_profile_image_user = avatar_profile_image_user
        this.flag_login_user = flag_login_user
        this.observation_flag_login_user = observation_flag_login_user
      })

    this.$store.dispatch('fetchCountries')

  }
}
</script>

<style scoped>
.cropper {
	height: 200px;
	background: #DDD;
}
</style>